
import React      from 'react';
import CSSModules from 'react-css-modules';

import styles from './style.scss';

import HeaderNavigation from '../HeaderNavigation';
import PageHeader      from '../PageHeader';

import { connect } from 'react-redux';
import navigator from '../../services/navigator';

const GetLogo = props => {

    if(!props.show) return null;

    return (
        <a href="/" onClick={(e) => { e.preventDefault(); navigator.push('/'); }} className={styles['logo-container']}>
            <img className={styles['logo']} src="/assets/images/rhe_logo_white.png" />
            <span className={styles['training-navigation-header']}>training</span>
        </a>
    )
};

class Header extends React.Component {

    constructor(props) {
        super(props);

        this.state = {scrollHeader: false};
    }

    componentDidMount() {
        this.setState({scrollHeader: false});
        window.addEventListener('scroll', this.handleScroll.bind(this));
    };

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll.bind(this));
    };

    handleScroll() {
        if (window.pageYOffset > 400) {
            this.setState({scrollHeader: true});
        }
        if (window.pageYOffset <= 400) {
            this.setState({scrollHeader: false});
        }
    };

    _getHeaderStyling() {

        if (this.props.isDashboard || this.state.scrollHeader || this.props.pathName) {
            return 'scroll-header';
        }

        return 'header';
    }

    render() {

        const headerStyle = this._getHeaderStyling();

        return (
            <div>
                <header styleName={headerStyle} id="menu-header">

                    <div className={styles[!this.props.isDashboard ? 'section-content' : '']}>
                        <GetLogo
                            show={this.state.scrollHeader || this.props.pathName || this.props.isDashboard}
                        />

                        {!this.props.isDashboard && (<HeaderNavigation scrollHeader={this.state.scrollHeader || this.props.pathName}/>)}

                    </div>

                </header>

                <PageHeader pathName={this.props.pathName} />

            </div>
        );
    }
}

function mapStateToProps(state) {
    return state.header;
}

function mapDispatchToProps(dispatch) {
    return {
        toggleMobileMenu() {
            dispatch({
                type: 'TOGGLE_MOBILE_MENU'
            });
        },
        toggleMobileSearch() {
            dispatch({
                type: 'TOGGLE_MOBILE_SEARCH'
            });
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(Header, styles));


// WEBPACK FOOTER //
// ./components/Header/index.js